import { mimeTypes } from '@/modules/base/util/constants'
const {
  MIMETYPE_JPG,
  MIMETYPE_JPEG,
  MIMETYPE_PNG,
  MIMETYPE_PDF,
  MIMETYPE_DOC,
  MIMETYPE_DOCX,
  MIMETYPE_XLS,
  MIMETYPE_XLSX,
  MIMETYPE_PPT,
  MIMETYPE_PPTX,
  MIMETYPE_CSV,
} = mimeTypes

const mimeTypeToReadableMap = new Map([
  { key: MIMETYPE_PDF, value: 'PDF' },
  { key: MIMETYPE_JPG, value: 'JPG' },
  { key: MIMETYPE_JPEG, value: 'JPG' },
  { key: MIMETYPE_PNG, value: 'PNG' },
  { key: MIMETYPE_DOC, value: 'DOC' },
  { key: MIMETYPE_DOCX, value: 'DOCX' },
  { key: MIMETYPE_XLS, value: 'XLS' },
  { key: MIMETYPE_XLSX, value: 'XLSX' },
  { key: MIMETYPE_PPT, value: 'PPT' },
  { key: MIMETYPE_PPTX, value: 'PPTX' },
  { key: MIMETYPE_CSV, value: 'CSV' },
].map(obj => [obj.key, obj.value]))

export const mimeTypeToReadable = (value) => {
  const readable = mimeTypeToReadableMap.get(value)
  return readable || value
}
